module.exports = __webpack_public_path__ + "img/ic_phone.55dbd6f0.png";